// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"74b93a94fa8b5ef7fdff0192fd5a6f625a940261"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

function scrubPIIFromBreadcrumb(breadcrumb) {
  if (breadcrumb.data) {
    // Redact sensitive data fields
    if (breadcrumb.data.token) breadcrumb.data.token = '[REDACTED]';
    if (breadcrumb.data.password) breadcrumb.data.password = '[REDACTED]';
  }
  if (breadcrumb.message) {
    // Redact sensitive information in messages
    breadcrumb.message = breadcrumb.message.replace(/(token=)[^&]+/, '$1[REDACTED]');
    breadcrumb.message = breadcrumb.message.replace(/(password=)[^&]+/, '$1[REDACTED]');
  }
  if (breadcrumb.category === 'navigation' && breadcrumb.data) {
    if (breadcrumb.data.to) {
      breadcrumb.data.to = '/#[REDACTED]';
    }
    if (breadcrumb.data.from) {
      breadcrumb.data.from = '/#[REDACTED]';
    }
  }
  return breadcrumb;
}

function scrubPIIFromEvent(event) {
  if (event.breadcrumbs) {
    event.breadcrumbs = event.breadcrumbs.map(scrubPIIFromBreadcrumb);
  }
  return event;
}

async function initSentry() {
  let dsn = null;
  try {
    const res = await fetch('/api/sentry-dsn');
    if (res.ok) {
      dsn = (await res.json()).dsn ?? null;
    }
  } catch {
    // non-critical — Sentry stays disabled if the endpoint is unreachable
  }

  if (dsn) {
    console.info('[Sentry] Initialising client SDK (service=action-portal, env=client)');
  } else {
    console.info('[Sentry] SDK disabled (SENTRY_DSN not available)');
  }

  Sentry.init({
    dsn,
    enabled: !!dsn,
    tracesSampleRate: 0.1,
    debug: false,
    initialScope: {
      tags: {
        service: 'action-portal',
        version: process.env.NEXT_PUBLIC_COMMIT_SHA ?? 'unknown',
      },
    },
    beforeSend(event) {
      return scrubPIIFromEvent(event);
    },
  });
}

initSentry();
